import * as types from './compositionActionTypes';

const initialState = {
  compositionData: null,
  compositionList: [],
  createCompositionData: null,
  createCompositionError: null,
  updateCompositionData: null,
  updateCompositionError: null,
  deleteCompositionData: null,
  deleteCompositionError: null,
};

export const compositionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_COMPOSITION_DATA:
      return {
        ...state,
        compositionData: action.payload || null,
        compositionList: action.payload?.CompositionList || action.payload?.ThreadList || [],
      };
    case types.GET_COMPOSITION_ERROR:
      return {
        ...state,
        compositionData: null,
        compositionList: [],
      };
    case types.CREATE_COMPOSITION_DATA:
      return {
        ...state,
        createCompositionData: action.payload,
        createCompositionError: null,
      };
    case types.CREATE_COMPOSITION_ERROR:
      return {
        ...state,
        createCompositionData: null,
        createCompositionError: action.payload,
      };
    case types.UPDATE_COMPOSITION_DATA:
      return {
        ...state,
        updateCompositionData: action.payload,
        updateCompositionError: null,
      };
    case types.UPDATE_COMPOSITION_ERROR:
      return {
        ...state,
        updateCompositionData: null,
        updateCompositionError: action.payload,
      };
    case types.DELETE_COMPOSITION_DATA:
      return {
        ...state,
        deleteCompositionData: action.payload,
        deleteCompositionError: null,
      };
    case types.DELETE_COMPOSITION_ERROR:
      return {
        ...state,
        deleteCompositionData: null,
        deleteCompositionError: action.payload,
      };
    default:
      return state;
  }
};
